import { type Semantic, getStatusSemantic } from "@/lib/status";

const styles: Record<Semantic, { badge: string; dot: string }> = {
  success: {
    badge: "badge-success bg-emerald-50 text-emerald-800 border-emerald-300",
    dot: "bg-[#10B981]",
  },
  info: { badge: "badge-info bg-sky-50 text-sky-800 border-sky-300", dot: "bg-[#0EA5E9]" },
  warning: {
    badge: "badge-warning bg-amber-50 text-amber-800 border-amber-300",
    dot: "bg-[#F59E0B]",
  },
  error: { badge: "badge-error bg-rose-50 text-rose-800 border-rose-300", dot: "bg-[#F43F5E]" },
  neutral: {
    badge: "badge-neutral bg-zinc-100 text-zinc-600 border-zinc-300",
    dot: "bg-[#7C8AA4]",
  },
};

export function StatusBadge({ status }: { status: string }) {
  const semantic = getStatusSemantic(status);
  const s = styles[semantic];
  return (
    <output
      aria-label={`Status: ${status}`}
      className={`inline-flex items-center gap-1.5 rounded-[7px] border px-2 py-0.5 font-sans text-[11px] font-semibold leading-none ${s.badge}`}
    >
      <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {status}
    </output>
  );
}
